function SingleMsg({
  item,
  selectedMsgId,
  handleShowSingleMsg,
  handleDeleteSingleMsg,
  handleFlagChange,
}) {
  const handleFlagClick = () => {
    const flag = item?.redFlag === '1' ? '0' : '1';
    handleFlagChange(item?.msgId, item?.type, flag);
  };
  return (
    <div
      className={`${
        selectedMsgId === item?.msgId
          ? 'comm-msglist-sndrcv flex-sec actv-thrd'
          : `comm-msglist-sndrcv flex-sec ${item?.unreadCl}`
      } `}
    >
      <div
        className="comm-msglist-sndrcv-lt grid-sec"
        onClick={() => handleShowSingleMsg(item?.msgId, item?.type)}
      >
        {(() => {
          if (item?.type === '1') {
            return (
              <>
                <span className="sndrcv-lt-nm flex-sec">
                  {/* <span
                    className="com-icon hide"
                    dangerouslySetInnerHTML={{
                      __html: item?.msgIcon,
                    }}
                  ></span> */}
                  <span className="com-icon">
                    <img
                      style={{ width: '80%', marginTop: '5px' }}
                      src={item?.msgIcon}
                      alt=""
                    />
                  </span>

                  <span className="grid-sec">
                    {/* <span className="width100">{item?.showName}</span> */}
                    <span className="width100">
                      {item?.box !== 'sent' && 'From:'}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item?.showName,
                        }}
                      />
                    </span>
                    {item?.chartNo && (
                      <span className="txt-thread-chrt">
                        {`ID: ${item?.chartNo}, DOB: ${item?.dob}`}{' '}
                        <span className="red">| </span>
                        {item?.mob}
                      </span>
                    )}
                    <span className="width100 fontsize13 sec-colr clear-top5">
                      {item?.box !== 'sent' && 'To:'}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item.toUser,
                        }}
                      />
                    </span>

                    <span className="sndrcv-lt-nmbr"></span>
                  </span>
                </span>
                <span
                  className="sndrcv-lt-msg"
                  dangerouslySetInnerHTML={{
                    __html: item?.subLine,
                  }}
                >
                  {/* {item?.subLine} */}
                </span>
              </>
            );
          } else if (item?.type === '2') {
            return (
              <>
                <span className="sndrcv-lt-nm grid-sec">
                  {/* <span
                    className="com-icon hide"
                    dangerouslySetInnerHTML={{
                      __html: item?.msgIcon,
                    }}
                  ></span> */}
                  <div className="left width100">
                    <span className="com-icon">
                      <img
                        style={{ width: '80%', marginTop: '5px' }}
                        src={item?.msgIcon}
                        alt=""
                      />
                    </span>
                    {/* <span className="">{item?.showName}</span> */}
                    <span className="width100">
                      {item?.box !== 'sent' && 'From:'}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item?.showName,
                        }}
                      />
                    </span>
                  </div>
                  {item?.chartNo && (
                    <span className="txt-thread-chrt">
                      {`ID: ${item?.chartNo}, DOB: ${item?.dob}`}{' '}
                      {item?.mob && (
                        <>
                          <span className="red">&nbsp;|&nbsp;</span>
                          {item?.mob}
                        </>
                      )}
                    </span>
                  )}
                  <div className="width100 fontsize13 sec-colr clear-top5">
                    {item?.box !== 'sent' && 'To:'}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: item.toUser,
                      }}
                    />
                  </div>
                </span>
                <span className="sndrcv-lt-msg  ">{item?.subLine}</span>
                <span className="sndrcv-lt-msg ">{item?.msgLine}</span>
              </>
            );
          } else if (item?.type === '3') {
            return (
              <>
                <span className="sndrcv-lt-nm grid-sec">
                  {/* <span
                    className="com-icon hide"
                    dangerouslySetInnerHTML={{
                      __html: item?.msgIcon,
                    }}
                  ></span> */}
                  {item?.box === 'inbox' ? (
                    <>
                      <span className="width100">
                        From:{' '}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item?.showName,
                          }}
                        />
                      </span>
                      <span className="width100 fontsize13 sec-colr clear-top5">
                        To:{' '}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.toUser,
                          }}
                        />
                      </span>
                    </>
                  ) : (
                    <span
                      className="sndrcv-lt-msg"
                      dangerouslySetInnerHTML={{
                        __html: item?.showName,
                      }}
                    />
                  )}
                </span>
                <span
                  className="sndrcv-lt-msg"
                  dangerouslySetInnerHTML={{
                    __html: item?.subLine,
                  }}
                >
                  {/* {item?.subLine} */}
                </span>
                <span
                  className="sndrcv-lt-msg "
                  dangerouslySetInnerHTML={{
                    __html: item?.msgLine,
                  }}
                >
                  {/* {item?.msgLine} */}
                </span>
              </>
            );
          }
        })()}

        <span className="sndrcv-lt-tim clear-top5">
          {item?.msgSentReceiveTime}
        </span>
      </div>
      <div>
        <span
          className={
            selectedMsgId === item?.msgId
              ? 'sndrcv-lt-dlt hide'
              : 'sndrcv-lt-dlt'
          }
          onClick={() => handleDeleteSingleMsg(item?.msgId, item?.type)}
        >
          &#128465;
        </span>
        <span
          className={
            item?.redFlag === '1'
              ? 'sndrcv-lt-dlt actv-cm-flagged'
              : 'sndrcv-lt-dlt'
          }
          onClick={handleFlagClick}
        >
          &#9872;
        </span>
      </div>
    </div>
  );
}

export default SingleMsg;
